import React, { useEffect, useState } from "react";
import { api, euro, formatApiErrorDetail } from "@/lib/api";
import { ServicePageHeader } from "@/components/ServiceHistoryButton";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { toast } from "sonner";
import { Zap } from "lucide-react";

export default function Ricariche() {
  const [products, setProducts] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selected, setSelected] = useState(null);
  const [phone, setPhone] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/products", { params: { category: "ricarica" } }).then((r) => setProducts(r.data)).catch(() => {});
    api.get("/customers").then((r) => setCustomers(r.data)).catch(() => {});
  }, []);

  const checkout = async () => {
    if (!selected) { toast.error("Seleziona un taglio di ricarica"); return; }
    if (!phone) { toast.error("Inserisci il numero di telefono"); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/payments/checkout", {
        product_id: selected, quantity: 1, origin_url: window.location.origin,
        phone_number: phone, customer_id: customerId || null,
      });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Errore checkout");
      setLoading(false);
    }
  };

  return (
    <div className="service-page-wide space-y-5 w-full max-w-none" data-testid="ricariche-page">
      <ServicePageHeader service="ricariche">
        <p className="text-xs font-medium tracking-wider uppercase text-muted-foreground">Servizi</p>
        <h1 className="font-head text-3xl font-bold tracking-tight mt-1">Ricarica telefonica</h1>
      </ServicePageHeader>
      <Card className="topup-layout p-5 glow-border">
        <div className="topup-fields space-y-4">
          <div>
            <Label>Cliente (opzionale)</Label>
            <Select value={customerId} onValueChange={setCustomerId}>
              <SelectTrigger className="mt-1.5" data-testid="ricarica-customer-select"><SelectValue placeholder="Associa a un cliente" /></SelectTrigger>
              <SelectContent>{customers.map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div><Label htmlFor="rphone">Numero di telefono</Label><Input type="tel" id="rphone" className="mt-1.5" data-testid="ricarica-phone" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="+39 3xx xxxxxxx" /></div>
        </div>
        <div className="topup-offers">
          <Label>Taglio ricarica</Label>
          <div className="topup-offer-grid gap-3 mt-2">
            {products.map((p) => (
              <button key={p.id} type="button" data-testid={`ricarica-option-${p.id}`}
                onClick={() => setSelected(p.id)}
                className={`rounded-xl border p-4 text-center transition-all ${selected === p.id ? "border-primary bg-primary/10 ring-2 ring-primary" : "border-border hover:border-primary/50"}`}>
                <p className="font-head text-xl font-bold">{euro(p.price)}</p>
                <p className="text-xs text-muted-foreground mt-1">{p.operator}</p>
              </button>
            ))}
          </div>
        </div>
        <Button onClick={checkout} disabled={loading} className="topup-submit gap-2" data-testid="ricarica-checkout-button">
          <Zap className="w-4 h-4" /> {loading ? "Attendi…" : "Procedi al pagamento"}
        </Button>
      </Card>
    </div>
  );
}
